// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

/**
 * @deprecated use "@tock/icons" import instead
 * This new package will be where all Icons are imported from going forward
 * You can still use these icons in <IconMigrationUtil /> as the legacy icon
 */
export const SvgIconSavePin = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: '1em', height: '1em', viewBox: '0 0 24 24', fill: 'none', ...props },
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.103 6.612L17.39.9a2.217 2.217 0 00-3.438.377l-3.785 5.95a8.105 8.105 0 00-5.438.981l-.003.002a2.217 2.217 0 00-.443 3.481l3.483 3.484L.47 22.47a.75.75 0 101.06 1.06l7.296-7.296 3.485 3.485.001.001a2.216 2.216 0 003.481-.444l.002-.003a8.104 8.104 0 00.981-5.438l5.949-3.785a2.217 2.217 0 00.378-3.438zm-7.359-4.858a.717.717 0 01.585.206l5.713 5.713a.716.716 0 01-.123 1.111l-6.383 4.063a.75.75 0 00-.327.808 6.605 6.605 0 01-.71 4.863.717.717 0 01-1.125.142L5.343 10.63h-.001a.717.717 0 01.142-1.126 6.605 6.605 0 014.863-.71.75.75 0 00.808-.327l4.063-6.384a.717.717 0 01.526-.328z"
      fill="currentColor"
    />
  );
export default SvgIconSavePin;
